<template>
  <v-card class="pa-6">
    <div class="d-flex align-center">
      <v-spacer></v-spacer>
      <h2 class="ml-12">{{ isEditing ? 'Atualizar' : 'Novo' }} parâmetro</h2>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider class="mt-2 mb-3"></v-divider>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label>Nome</label>
          <v-text-field
            v-model="parameter.name"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite o nome do parâmetro"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <label>Métrica</label>
          <v-autocomplete
            v-model="parameter.metricId"
            hide-details="auto"
            :disabled="loading"
            :items="calibrationMetrics"
            item-value="id"
            item-text="name"
            append-icon="mdi-chevron-down"
            placeholder="Selecione a métrica"
            outlined
            class="primary-input"
          >
            <template v-slot:item="{ item }">
              <span class="text-caption" v-if="!item.name.includes('(')">
                {{ item.name }} ({{ item.unit }})
              </span>
              <span class="text-caption" v-else>
                {{ item.name }}
              </span>
            </template>
            <template v-slot:selection="{ item }">
              <span class="text-caption" v-if="!item.name.includes('(')">
                {{ item.name }} ({{ item.unit }})
              </span>
              <span class="text-caption" v-else>
                {{ item.name }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="7">
          <label>Tolerância</label>
          <v-text-field
            type="number"
            v-model="parameter.tolerance"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite a tolerância"
            :suffix="parameter.isAbsoluteValue ? 'VL' : '%'"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="5">
          <label>Tipo de valor</label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="parameter.isAbsoluteValue"
            hide-details="auto"
            item-text="text"
            item-value="value"
            :items="[
              {
                text: 'Valor absoluto',
                value: true,
              },
              {
                text: 'Valor percentual',
                value: false,
              },
            ]"
            :disabled="loading"
            placeholder="Digite o nome do parâmetro"
            outlined
            class="primary-input"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex px-1 mt-3">
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button mr-0"
        depressed
        :loading="loading"
        @click="submit"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'ManageParameter',

  props: {
    parameterId: Number,
    templateId: String,
  },

  created() {
    this.getMetrics()
    if (this.parameterId) {
      this.isEditing = true
      this.getSelectedParameter()
    }
  },

  data() {
    return {
      loading: false,
      calibrationMetrics: [],
      parameter: {
        isAbsoluteValue: false,
      },
      isEditing: false,
      apiService: new ApiService(),
    }
  },

  methods: {
    getMetrics() {
      this.apiService.get('calibration/v2/metric/list').then((response) => {
        this.calibrationMetrics = response.content
      })
    },

    getSelectedParameter() {
      this.apiService
        .get('calibration/v2/standard-template/parameter/' + this.parameterId)
        .then((response) => {
          this.parameter = response.content
        })
    },

    add() {
      this.loading = true
      this.apiService
        .post('calibration/v2/standard-template/parameter', this.parameter)
        .then((response) => {
          this.loading = false
          this.$toast.success('Parâmetro cadastrado com sucesso!')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true
      this.apiService
        .put('calibration/v2/standard-template/parameter', this.parameter)
        .then((response) => {
          this.loading = false
          this.$toast.success('Parâmetro atualizado com sucesso!')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      this.parameter.templateId = this.templateId
      this.parameter.tolerance = this.parameter.tolerance
        .toString()
        .replace(',', '.')

      if (this.isEditing) this.edit()
      else this.add()
    },
  },
}
</script>

<style></style>
